import {searchSvg as Icon__small__searchSvg} from '../Icon__small/Icon__small--search.js';
import {searchSvg as Icon__xsmall__searchSvg} from '../Icon__xsmall/Icon__xsmall--search.js';
import {searchSvg as Icon__xxsmall__searchSvg} from '../Icon__xxsmall/Icon__xxsmall--search.js';

export var search = {
  name: 'search',
  category: 'icon',
  colorable: true,
  svg: Icon__small__searchSvg,
  alt: {
    Icon__small: Icon__small__searchSvg,
    Icon__xsmall: Icon__xsmall__searchSvg,
    Icon__xxsmall: Icon__xxsmall__searchSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall', 'Icon__xxsmall'],
};
